import dynamic from 'next/dynamic'

export const DynamicSearchFiltersDrawer = dynamic(
  () => import('.').then((mod) => mod.SearchFiltersDrawer),
  { ssr: false },
)
